import { CtrlType } from "@yuigoto/ctrl";

export const ElementsControl = [
  {
    name: "first_name",
    label: "Single Line",
    placeholder: "Digite seu nome...",
    required: true,
    type: CtrlType.DEFAULT,
    description: "Descrição de teste para Você."
  },
  {
    name: "cep",
    label: "CEP",
    placeholder: "ZIP",
    required: true,
    type: CtrlType.CEP,
    description: "CEP, rapaz."
  },
  {
    name: "email",
    label: "E-Mail",
    placeholder: "mail@mail.com",
    type: CtrlType.EMAIL
  },
  {
    name: "senha",
    label: "Senha",
    placeholder: "**********",
    required: true,
    type: CtrlType.PASSWORD
  },
  [
    {
      name: "cpf",
      label: "CPF",
      placeholder: "000.000.000-00",
      type: CtrlType.CPF,
      required: true,
      wrapClass: "col-4"
    },
    {
      name: "cnpj",
      label: "CNPJ",
      placeholder: "00.000.000-0000/00",
      type: CtrlType.CNPJ,
      required: true,
      wrapClass: "col-4"
    },
    {
      name: "pis",
      label: "PIS",
      placeholder: "00.00000.000-0",
      type: CtrlType.PIS,
      required: true,
      wrapClass: "col-4"
    }
  ],
  {
    name: "url",
    label: "URL",
    placeholder: "http://...",
    type: CtrlType.URL,
    required: true
  },
  {
    name: "message",
    label: "Textarea",
    type: CtrlType.TEXTAREA,
    placeholder: "Textinho bacanudo",
    cols: 30,
    rows: 8
  },
  {
    name: "radio_default",
    label: "Options",
    type: CtrlType.RADIO_GROUP,
    required: true,
    options: [
      {
        value: 1,
        name: "Default Radio"
      },
      {
        disabled: true,
        value: 2,
        name: "Default Radio (Disabled)"
      },
      {
        custom: true,
        value: 3,
        name: "Custom Default Radio"
      },
      {
        custom: true,
        disabled: true,
        value: 4,
        name: "Custom Default Radio (Disabled)"
      }
    ]
  },
  {
    required: true,
    name: "radio_inline",
    label: "Options (Inline)",
    type: CtrlType.RADIO_GROUP,
    options: [
      {
        inline: true,
        value: 1,
        name: "Default Radio"
      },
      {
        inline: true,
        disabled: true,
        value: 2,
        name: "Default Radio (Disabled)"
      },
      {
        inline: true,
        custom: true,
        value: 3,
        name: "Custom Default Radio"
      },
      {
        inline: true,
        custom: true,
        disabled: true,
        value: 4,
        name: "Custom Default Radio (Disabled)"
      }
    ]
  },
  {
    required: true,
    name: "checkbox_default",
    label: "Checkboxes",
    type: CtrlType.CHECKBOX_GROUP,
    options: [
      {
        value: 1,
        name: "Default Checkbox"
      },
      {
        disabled: true,
        value: 2,
        name: "Default Checkbox (Disabled)"
      },
      {
        custom: true,
        value: 3,
        name: "Custom Default Checkbox"
      },
      {
        custom: true,
        disabled: true,
        value: 4,
        name: "Custom Default Checkbox (Disabled)"
      }
    ]
  },
  {
    required: true,
    name: "checkbox_inline",
    label: "Checkboxes (Inline)",
    type: CtrlType.CHECKBOX_GROUP,
    options: [
      {
        inline: true,
        value: 1,
        name: "Default Checkbox"
      },
      {
        inline: true,
        disabled: true,
        value: 2,
        name: "Default Checkbox (Disabled)"
      },
      {
        inline: true,
        custom: true,
        value: 3,
        name: "Custom Default Checkbox"
      },
      {
        inline: true,
        custom: true,
        disabled: true,
        value: 4,
        name: "Custom Default Checkbox (Disabled)"
      }
    ]
  },
  {
    name: "boolean",
    label: "Boolean Input",
    type: CtrlType.BOOLEAN
  },
  {
    name: "boolean_custom",
    label: "Boolean Input (Custom)",
    type: CtrlType.BOOLEAN,
    custom: true
  },
  {
    name: "dropdown",
    label: "Dropdown Selector",
    type: CtrlType.DROPDOWN,
    required: true,
    options: [
      {
        name: "Selecione",
        value: ""
      },
      {
        name: "Option 1",
        value: 1
      },
      {
        name: "Option 2",
        value: 2
      },
      {
        name: "Option 3",
        value: 3
      }
    ]
  },
  {
    name: "dropdown_custom",
    label: "Dropdown Selector (Custom)",
    type: CtrlType.DROPDOWN,
    custom: true,
    required: true,
    options: [
      {
        name: "Selecione",
        value: ""
      },
      {
        name: "Option 1",
        value: 1
      },
      {
        name: "Option 2",
        value: 2
      },
      {
        name: "Option 3",
        value: 3
      }
    ]
  }
];
